module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\n  <div class="mediaUpload mediaUpload-noBorder is-loading">\n      ';
 // This image stretches container to fill height and width available while actual image is being fetched 
__p+='\n      <img class="mediaUpload__loadingStretch responsiveImage responsiveImage-scale"\n          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII=">\n  </div>\n</div>\n';
}
return __p;
};
